import { Component, Input } from '@angular/core';
import { AnalyticsService } from '../../@core/utils/analytics.service';
import { StorageService } from '../../services/storage.service';

@Component({
  selector: 'ngx-mobile-compatibility-check',
  templateUrl: './mobile-compatibility-check.component.html',
  styleUrl: './mobile-compatibility-check.component.scss',
})
export class MobileCompatibilityCheckComponent {
  // added the input decorator to dynamically display page name
  @Input() pageName: string;
  constructor(
    public storageService: StorageService,
    public analyticsService: AnalyticsService,
  ) {}
}
